import { useGetTrustpilotRating } from 'builder/hooks/useGetTrustpilotRating'
import { useI18n } from 'builder/hooks/useI18n'
import EmptyStar from './assets/green-star-empty.svg'
import FullStar from './assets/green-star-full.svg'
import HalfStar from './assets/green-star-half.svg'
import TrustpilotLogo from './assets/logo.svg'
import {
  Container,
  Logo,
  LogoMobile,
  MobileContainer,
  Rating,
  RatingContainerHorizontal,
  RatingNumberHorizontal,
  RatingNumberHorizontalMobile,
  StarImage,
} from './styles'

export const TRANSLATION_PREFIX = `builder.billing.trustpilot`

export const TrustpilotRatingHorizontal = () => {
  const trustpilotRating = useGetTrustpilotRating()
  const { i18n } = useI18n()
  const totalReviews = i18n.t(`${TRANSLATION_PREFIX}.based_on_horizontal`, {
    reviews: trustpilotRating.data?.number_of_reviews.total,
  })

  const roundedRating = trustpilotRating.data
    ? Math.round(trustpilotRating.data.score.stars * 2) / 2
    : 0

  function getRatingString(value: number): string {
    if (value < 2) {
      return 'bad'
    } else if (value < 3) {
      return 'poor'
    } else if (value < 4) {
      return 'average'
    } else if (value === 4) {
      return 'great'
    } else return 'excellent'
  }

  return (
    <Container>
      <RatingContainerHorizontal>
        <Rating $useMargin={false}>
          {i18n.t(`${TRANSLATION_PREFIX}.${getRatingString(roundedRating)}`)}
        </Rating>
        <div style={{ display: 'flex' }}>
          {Array(Math.floor(roundedRating))
            .fill(FullStar)
            .map((star, i) => (
              <StarImage src={star} key={i} alt={`star ${i}`} />
            ))}
          {roundedRating % 1 === 0.5 && <StarImage src={HalfStar} alt="halfstar" />}
          {Array(5 - Math.ceil(roundedRating))
            .fill(EmptyStar)
            .map((star, i) => (
              <StarImage src={star} key={i} alt={`emptystar ${i}`} />
            ))}
        </div>
        <RatingNumberHorizontal dangerouslySetInnerHTML={{ __html: totalReviews }} />
        <Logo src={TrustpilotLogo} />
      </RatingContainerHorizontal>
      <MobileContainer>
        <RatingNumberHorizontalMobile dangerouslySetInnerHTML={{ __html: totalReviews }} />
        <LogoMobile src={TrustpilotLogo} />
      </MobileContainer>
    </Container>
  )
}
